<template>
    <path d="M29.1035 10.3711H1.50201" stroke-width="2" />
    <path d="M10.373 1.5L1.50113 10.3719L10.373 19.2438" stroke-width="2" stroke-linecap="square" />
</template>
